export default __webpack_public_path__ + "static/6-3da9638aa2045397c5a9a15b19af1cf0.webp";